import React, { useEffect } from 'react';
import { Grid, Typography, Box, Divider, Skeleton } from '@mui/material';
import { HighChartTreemapChart } from '../../../shared';
import { ActionsIcon } from '../../../../assets';
import { CHART_OPTIONS_KEYWORD_3 } from './constants';
import { useDispatch, useSelector } from 'react-redux';
import { getContentAffinityKeywords } from '../../../../redux/thunks/physicanTargetListAnalysisThunk';

function ContentAffinity(props) {
    const {} = props;
    const dispatch = useDispatch()
    const { company } = useSelector(state => state.company);
    const { contentAffinity } =useSelector(state => state.physicianTargetListAnalysis);
    const { chartSeries, totalKeywordsCount, isLoading } = contentAffinity;
    
    useEffect(() => {
        if(company.id){
            dispatch(getContentAffinityKeywords({companyId: company.id}))
        }
        
    },[company.id])

    return (
        <Box className="box-sizing-border-box">
            <Typography className="text-lg-semi-bold gray-900">
                Content Affinity
            </Typography>
            <Box className="padding-tb-24-rl-0">
                <Grid container spacing={'24px'} className="flex-row br-16px">
                    <Grid item xs={12}>
                        {/*  Keyword 2 */}
                        <Box className="padding-24px bg-gray-50 br-16px">
                            <Box className="pb-24px" >
                                <Box className="flex-column gap-4">
                                    <Box className="flex-row-space-between">
                                        <Box>
                                            <Typography className="text-md-semi-bold gray-900">
                                                Keywords
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Typography className="text-sm-regular gray-500">
                                            {totalKeywordsCount} Overall Keywords
                                        </Typography>
                                    </Box>
                                </Box>
                                <Divider className="border-1-gray mt-20px" />
                            </Box>
                            {/* Keyword 2 Bubble Chart*/}
                            <Box className="height-396px">
                                {
                                    isLoading 
                                    ?   <Skeleton variant='rectangular' width={'100%'} height={"400px"}/> 
                                    :   <HighChartTreemapChart
                                            chartOptions={
                                                {
                                                    ...CHART_OPTIONS_KEYWORD_3,
                                                    series: chartSeries,
                                                }
                                            }
                                        />
                                }
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}

export default ContentAffinity;
